export default "/images/pr-img-4.png?d8a58ef2b40abb45c66b6a1d45be10cb";